import React from "react"

const Tech = () => {
  return (
    <div className="card">
      <div className="container-fluid px-0">
        <div className="row">
          <div className="col-12 col-md-6">
            <h5>General Purpose</h5>
            <p>
              JavaScript, TypeScript, Python, Go/Golang, Dart, Java, C/C++,
              MATLAB
            </p>
            <h5>Web</h5>
            <p>
              React, Redux, Context, MobX, Gatsby, Next, Node, Express,
              Storybook, Django, Flask, Lerna, Rush, Grafana, EJS, Liquid,
              jQuery, HTML/CSS
            </p>
            <h5>Mobile</h5>
            <p>
              Swift, SwiftUI, UIKit, MusicKit, React Native, Flutter, Capacitor,
              CocoaPods, Alamofire, TestFlight, Lottie
            </p>
            <h5>Styling</h5>
            <p>
              SCSS/SASS, LESS, Tailwind, Bootstrap, Bulma, Material-UI, Ant
              Design, styled-components
            </p>
          </div>
          <div className="col-12 col-md-6 col-1-format">
            <h5>Databases &amp; Deployment</h5>
            <p>
              PostgreSQL, SQL, GraphQL, GQL, Apollo, NoSQL, Firebase, AWS, GCP,
              Azure, MongoDB, Mongoose, InfluxDB, Heroku, Netlify, Vercel,
              Jenkins
            </p>
            <h5>Testing</h5>
            <p>Jest, Enzyme, Postman, Insomnia, Flipper, Reactotron</p>
            <h5>Other</h5>
            <p>
              Git, Linux, Bash (Shell), Progressive Web Apps (PWA), JSON, XML,
              REST APIs, Microservices, Monorepo, Agile Software Development,
              Scrum, Kanban, Jira
            </p>
            <h5>Design</h5>
            <p>
              Blender, Maya, Illustrator, Photoshop, InDesign, XD, Sketch,
              Figma, Zeplin, Supernova Studio, Webflow, Squarespace
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Tech
